import { jsx as C } from "react/jsx-runtime";
const e = () => /* @__PURE__ */ C(
  "path",
  {
    d: "M11.5236 2.06046C11.9413 1.40404 12.7423 1.10225 13.4893 1.31978C14.2363 1.53732 14.75 2.22193 14.75 2.99999V8.25L18 8.25C18.6387 8.25 19.2267 8.59798 19.5341 9.15788C19.8414 9.71778 19.8193 10.4007 19.4764 10.9395L12.4764 21.9395C12.0587 22.5959 11.2578 22.8977 10.5107 22.6802C9.7637 22.4627 9.25 21.778 9.25 21L9.25 15.75H6C5.36128 15.75 4.7733 15.402 4.46594 14.8421C4.15858 14.2822 4.18068 13.5993 4.52359 13.0605L11.5236 2.06046ZM12.75 3.8585L6.45542 13.75H10.25C10.8023 13.75 11.25 14.1977 11.25 14.75L11.25 20.1415L17.5446 10.25L13.75 10.25C13.1977 10.25 12.75 9.80228 12.75 9.25V3.8585Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }
);
export {
  e as default
};
